module.exports = __webpack_public_path__ + "img/25.5bcb174e.png";